module.exports = __webpack_public_path__ + "static/media/storie-ig-postflow.5cd87d23.svg";